import { useState } from "react";

const EmployeeEmailEditorPopup = ({
  closeModal,
  employee,
  employeeInformationId,
  setIsModalOpen,
  updateEmployeeData
}) => {
  const [email, setEmail] = useState("");
  const [updateMessage, setUpdateMessage] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateError, setUpdateError] = useState("");

  const handleUpdate = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!email) {
      setUpdateError("Please enter an email address.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setUpdateError(
        "Please enter a valid email format (e.g. name@example.com).",
      );
      return;
    }

    setIsUpdating(true);
    setUpdateMessage("");
    setUpdateError("");

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken}`);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      employee_information_id: employeeInformationId,
      office_email: email,
    });

    const requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/employees/office_email`,
        requestOptions,
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Failed to update email.");
      }

      setUpdateMessage("Email updated successfully!");
      updateEmployeeData()
      setTimeout(() => {
        setIsModalOpen(false);
      }, 1500);
    } catch (error) {
      setUpdateError(
        error.message || "Something went wrong. Please try again.",
      );
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl py-6 w-full max-w-xl mx-4">
        <div className="flex justify-between items-center mb-6 border-b px-6 pb-2">
          <h3 className="text-xl font-bold text-gray-800">
            Edit Employee Email
          </h3>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className="flex flex-col gap-3 justify-end px-6">
          <div>
            <label htmlFor="email" className="text-sm text-gray-600 mb-1 block">
              New Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setUpdateError("");
                setUpdateMessage("");
              }}
              placeholder={employee.official_email}
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 placeholder:text-gray-400"
            />
          </div>

          {/* Feedback Messages */}
          {updateError && <p className="text-sm text-red-500">{updateError}</p>}
          {updateMessage && (
            <p className="text-sm text-green-600">{updateMessage}</p>
          )}

          <div className="flex w-full gap-3">
            <button
              onClick={closeModal}
              className="w-full px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50 transition-colors"
              disabled={isUpdating}
            >
              Cancel
            </button>

            <button
              onClick={handleUpdate}
              disabled={isUpdating}
              className={`w-full px-4 py-2 bg-primary-hrms text-white rounded hover:bg-green-600 transition-colors flex items-center justify-center gap-2 ${
                isUpdating ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isUpdating ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeEmailEditorPopup;
